module.exports = __webpack_public_path__ + "img/drivers-6-w800.jpg";